var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreedotsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92628 14.5666C8.40893 14.5666 9.61085 15.7824 9.61085 17.265C9.61085 18.7477 8.40893 19.9635 6.92628 19.9635C5.44362 19.9635 4.2417 18.7477 4.2417 17.265C4.2417 15.7824 5.44362 14.5666 6.92628 14.5666Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92628 4.0365C8.40893 4.0365 9.61085 5.2523 9.61085 6.73495C9.61085 8.2176 8.40893 9.4334 6.92628 9.4334C5.44362 9.4334 4.2417 8.2176 4.2417 6.73495C4.2417 5.2523 5.44362 4.0365 6.92628 4.0365Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0734 14.5666C18.5561 14.5666 19.758 15.7824 19.758 17.265C19.758 18.7477 18.5561 19.9635 17.0734 19.9635C15.5908 19.9635 14.3889 18.7477 14.3889 17.265C14.3889 15.7824 15.5908 14.5666 17.0734 14.5666Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0734 4.0365C18.5561 4.0365 19.758 5.2523 19.758 6.73495C19.758 8.2176 18.5561 9.4334 17.0734 9.4334C15.5908 9.4334 14.3889 8.2176 14.3889 6.73495C14.3889 5.2523 15.5908 4.0365 17.0734 4.0365Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreedotsOn);
export default __webpack_public_path__ + "static/media/treedots_on.521535b5e5c2dff92503bf375b4dc25d.svg";
export { ForwardRef as ReactComponent };